import React, { useState } from "react";
import PostReaction from "./PostReaction";
import PostReactionMessage from "./PostReactionMessage";
import CommentsList from "./CommentsList";
import { ReactComponent as ChatIcon } from "assets/img/icons/comment.svg";
import { useMoodsContext } from "store/contexts/moodsContext";
import MenuOption from "./MenuOption";
import { useLocation } from "react-router-dom";
import { useTimelineContext } from "store/contexts/timelineContext";
import PostRate from "./PostRate";

export default ({ post }) => {
  const { moods } = useMoodsContext();
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const expression_id = param.get("expression_id");
  const [expressionsOpen, setExpressionsOpen] = useState(
    expression_id ? true : false
  );
  const { selectPost, innovation_dashboard } = useTimelineContext();
  const [noFooterPost] = useState([
    "checkin",
    "watercooler",
    "welcomemessage",
    "poll",
    "todo-list",
    "todo-list-item",
    "reteam-meeting",
    "coursecreation",
    "survey",
  ]);

  const handleExpressionClick = () => {
    if (selectPost) {
      return selectPost(post);
    }
    setExpressionsOpen(!expressionsOpen);
  };

  return (
    <>
      {!noFooterPost.includes(post?.type) && (
        <>
          <>
            <PostReactionMessage
              post={post}
              openEngagement={handleExpressionClick}
            />
            {innovation_dashboard && (
              <div className="post-footer post-footer-rate">
                <PostRate post={post} />
              </div>
            )}
            <div className="post-footer">
              <div className="post-actions">
                <div className="left-actions">
                  {Boolean(moods) && Boolean(moods.length) && (
                    <PostReaction post={post} />
                  )}
                  <span
                    className="p-comment-btn"
                    onClick={handleExpressionClick}
                  >
                    <ChatIcon className="mwh-15" /> Comment
                  </span>
                </div>
                {!innovation_dashboard && (
                  <MenuOption post={post} />
                )}
              </div>
            </div>
          </>
          {expressionsOpen && !selectPost && <CommentsList post={post} />}
        </>
      )}
    </>
  );
};
